import { Button } from 'base/ui/button';
import { IconRedoSmall, IconUndoSmall } from 'base/ui/icons';
import { Rows } from 'base/ui/layout';
import { UndoManager } from 'blocks/woot_woot/undo';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from './undo_redo_controls.css';

type UndoRedoControlsProps = {
  undoManager: UndoManager;
};

export const UndoRedoControls = observer(function UndoRedoControls({
  undoManager,
}: UndoRedoControlsProps) {
  const undo = React.useCallback(() => {
    undoManager.undo();
  }, [undoManager]);
  const redo = React.useCallback(() => {
    undoManager.redo();
  }, [undoManager]);
  return (
    <div className={styles.undoRedoControls}>
      <Rows spacing={8}>
        <Button
          variant="secondary"
          background="transparent"
          icon={IconUndoSmall}
          size="large"
          onClick={undo}
          disabled={!undoManager.canUndo}
          tooltip="Undo"
          tooltipPlacement="horizontal"
          tooltipShortcut="⌘Z"
        />
        <Button
          variant="secondary"
          background="transparent"
          icon={IconRedoSmall}
          size="large"
          onClick={redo}
          disabled={!undoManager.canRedo}
          tooltip="Redo"
          tooltipPlacement="horizontal"
          tooltipShortcut="⇧⌘Z"
        />
      </Rows>
    </div>
  );
});
